module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image12.767aad99.jpg";